import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  Input,
  SimpleChanges,
  Output,
} from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { EventEmitter } from '@angular/core';
import { GlobalsService } from 'src/app/shared/services/globals';
import * as moment from 'moment';

@Component({
  selector: 'app-active-plans',
  templateUrl: './active-plans.component.html',
  styleUrls: ['./active-plans.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class ActivePlansComponent implements OnInit {
  dataSource: any[];
  smallSize: boolean;
  ordenar: boolean = true;
  action_clicked: boolean = false;
  autor_clicked: boolean = false;
  date_clicked: boolean = false;
  lider_clicked: boolean = false;
  usuarioActivo: any;
  search = '';
  modulo = 'active_list';
  @Input() public data: any[];

  @Output() private emitAddNew = new EventEmitter<boolean>();
  @Output() private emitSelectPlan = new EventEmitter();
  @Output() public emitAddToHistoric = new EventEmitter();
  constructor(
    private translate: TranslateService,
    private breakpointObserver: BreakpointObserver,
    private globals: GlobalsService
  ) {}

  ngOnInit(): void {
    this.usuarioActivo = this.globals.user.id;

    // let lang=this.translate.currentLang;
    const layoutChanges = this.breakpointObserver.observe([
      '(min-width: 989px)',
    ]);
    layoutChanges.subscribe((result) => {
      this.smallSize = result.matches;
    });
    this.dataSource = this.data;
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.setArray();
  }
  /**
   * @name addNewPlan
   * @author Daniel Ramirez
   * @description se emite el evento para crear un nuevo plan
   */
  addNewPlan() {
    this.emitAddNew.emit(true);
  }
  /**
   * @name addToHistoric
   * @author Daniel Ramirez
   * @description se emite el evento para enviar el plan al historico
   */
  addToHistoric(data) {
    this.emitAddToHistoric.emit({
      plan_pda_id: [data.id],
      nombre: data.nombre,
      same_as_lider: this.usuarioActivo == data.lider_id ? true : false,
    });
  }
  /**
   * @name addData
   * @author Daniel Ramirez
   * @description se emite el evento de seleccion del plan de accion
   */
  addData(data) {
    this.emitSelectPlan.emit(data);
  }
  /**
   * @name setArray
   * @author Daniel Ramirez
   * @description se configura un array con los datos del plan,para el listado de planes
   */
  setArray() {
    this.dataSource = [];
    let data = this.data;
    if (data) {
      for (let i = 0; i < data.length; i++) {
        this.dataSource.push({
          nombre: data[i].nombre,
          id: data[i].id,
          autor: data[i].usuario_autor.usuario.name,
          autor_id: data[i].usuario_autor.usuario.id,
          fecha_creacion:
            this.translate.currentLang == 'es'
              ? moment
                  .utc(data[i].fecha_inicio, 'DD/MM/YYYY HH:mm:ss')
                  .local()
                  .format('DD/MM/YYYY HH:mm:ss')
              : moment
                  .utc(data[i].fecha_inicio, 'DD/MM/YYYY HH:mm:ss')
                  .local()
                  .format('MM/DD/YYYY HH:mm:ss'),
          fecha_inicio:this.translate.currentLang == 'es'
          ? moment
              .utc(data[i].fecha_inicio, 'DD/MM/YYYY HH:mm:ss')
              .local()
              .format('YYYY-MM-DD HH:mm:ss')
          : moment
              .utc(data[i].fecha_inicio, 'DD/MM/YYYY HH:mm:ss')
              .local()
              .format('YYYY-MM-DD HH:mm:ss'),
          objetivo: data[i].objetivo,
          situacion_tratar: data[i].situacion_tratar,
          aviso: data[i].aviso,
          unidad: data[i].unidad,
          integrantes: data[i].integrantes,
          acciones: data[i].acciones,
          unidad_monetaria: data[i].unidad_monetaria,
        });
        if (data[i].integrantes.length) {
          for (let j = 0; j < data[i].integrantes.length; j++) {
            if (data[i].integrantes[j].tipo == 1) {
              this.dataSource[i].lider =
                data[i].integrantes[j].usuario_organizacion.usuario.name;
              this.dataSource[i].lider_id =
                data[i].integrantes[j].usuario_organizacion.usuario.id;
            }
          }
        }
      }
    }
  }
  
  /**
   * @name order
   * @author Daniel Ramirez
   * @description se ordenan la lista de planes segun el criterio seleccionado
   */
  order(name: string) {
    this.ordenar ? this.asc(name) : this.desc(name);
  }
  //orden ascendente
  asc(name: string) {
    let tipo = name;
    if (tipo == 'nombre') {
      this.action_clicked = true;
      this.autor_clicked = false;
      this.date_clicked = false;
      this.lider_clicked = false;
      this.ordenar = false;
      this.dataSource.sort((a, b) => a.nombre.localeCompare(b.nombre));
    } else if (tipo == 'fecha_creacion') {
      this.action_clicked = false;
      this.autor_clicked = false;
      this.date_clicked = true;
      this.lider_clicked = false;
      this.ordenar = false;
      
      this.dataSource.sort((a, b) =>
        a.fecha_inicio.localeCompare(b.fecha_inicio)
      );
    } else if (tipo == 'autor') {
      this.action_clicked = false;
      this.autor_clicked = true;
      this.date_clicked = false;
      this.lider_clicked = false;
      this.ordenar = false;
      this.dataSource.sort((a, b) => a.autor.localeCompare(b.autor));
    } else if (tipo == 'lider') {
      this.action_clicked = false;
      this.autor_clicked = false;
      this.date_clicked = false;
      this.lider_clicked = true;
      this.ordenar = false;
      this.dataSource.sort((a, b) => a.lider.localeCompare(b.lider));
    }
  }
  //orden descendente
  desc(name: string) {
    let tipo = name;
    if (tipo == 'nombre') {
      this.action_clicked = true;
      this.autor_clicked = false;
      this.date_clicked = false;
      this.lider_clicked = false;
      this.ordenar = true;
      this.dataSource.sort((b, a) => a.nombre.localeCompare(b.nombre));
    } else if (tipo == 'fecha_creacion') {

      this.action_clicked = false;
      this.autor_clicked = false;
      this.date_clicked = true;
      this.lider_clicked = false;
      this.ordenar = true;
      this.dataSource.sort((b, a) =>
        a.fecha_inicio.localeCompare(b.fecha_inicio)
      );
    } else if (tipo == 'autor') {
      this.action_clicked = false;
      this.autor_clicked = true;
      this.date_clicked = false;
      this.lider_clicked = false;
      this.ordenar = true;
      this.dataSource.sort((b, a) => a.autor.localeCompare(b.autor));
    } else if (tipo == 'lider') {
      this.action_clicked = false;
      this.autor_clicked = false;
      this.date_clicked = false;
      this.lider_clicked = true;
      this.ordenar = true;
      this.dataSource.sort((b, a) => a.lider.localeCompare(b.lider));
    }
  }
}
